import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from '../../../shared/services/api.service';
import { LanguageService } from '../../../shared/services/language/language.service';
import { LATE_ERROR_STATE } from '../../../shared/helpers/error-state';

@Component({
    selector: 'urban-forgot',
    templateUrl: './forgot.component.html',
    styleUrls: ['./forgot.component.scss'],
    standalone: false,
    providers: [LATE_ERROR_STATE]
})
export class ForgotComponent implements OnInit, OnDestroy {
  public form: UntypedFormGroup;
  public correctInput: boolean = true;
  public errorInRequest: boolean = false;
  public stepper: number = 0;
  public isLoading: boolean = false;
  public isLittleScreen: boolean;
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (event.target.innerWidth > 800) {
      this.isLittleScreen = false;
    } else {
      this.isLittleScreen = true;
    }
  }

  constructor(private apiService: ApiService, private router: Router, private fb: UntypedFormBuilder,
              private language: LanguageService) {
    if (window.innerWidth > 800) {
      this.isLittleScreen = false;
    } else {
      this.isLittleScreen = true;
    }
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      mail: new UntypedFormControl('', Validators.email),
    })
  }

  submit() {
    this.errorInRequest = false
    this.correctInput = this.form.valid;
    if (this.form.valid) {
      this.isLoading = true;
      this.apiService.findEmailToResetPassword(this.form.get('mail').value, this.language.current)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (key: any) => {
            setTimeout(() => {
              this.isLoading = false;
              this.stepper = 1;
            }, 2000);
          },
          err => {
            setTimeout(() => {
              this.isLoading = false;
              this.errorInRequest = true
            }, 2000);
          }
      );
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

